import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "./assets/style.css";
import { auth, db } from "./firebase";
import firebase from "firebase/compat/app";


const Chapter3_4 = () => {
  const navigate = useNavigate();
  const [selectedAnswers, setSelectedAnswers] = useState({ q1: "", q2: "" });
  const [error, setError] = useState("");
  const [userId, setUserId] = useState(null);

  const questions = [
    {
      question:
        "Frage 1: Was ist der Hauptunterschied zwischen einem DoS- und einem DDoS-Angriff?",
      options: [
        {
          value: "A",
          label:
            "Ein DDoS-Angriff nutzt viele Geräte gleichzeitig, während ein DoS-Angriff von einem einzelnen Gerät ausgeführt wird.",
        },
        {
          value: "B",
          label: "Ein DoS-Angriff ist stärker als ein DDoS-Angriff.",
        },
      ],
      correct: "A",
    },
    {
      question: "Frage 2: Welches Ziel verfolgen DoS- und DDoS-Angriffe?",
      options: [
        {
          value: "A",
          label: "Die Überlastung eines Systems, um es unerreichbar zu machen.",
        },
        {
          value: "B",
          label: "Die Verschlüsselung von Daten, um Lösegeld zu fordern.",
        },
      ],
      correct: "A",
    },
  ];

 useEffect(() => {
  window.scrollTo({ top: 0, left: 0, behavior: "auto" });
}, []);


  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserId(user.uid); 
      } else {
        console.error("Kein authentifizierter Benutzer gefunden");
        setError("Benutzer ist nicht authentifiziert");
        navigate("/login"); 
      }
    });

   
    return () => unsubscribe();
  }, [navigate]);

  
  useEffect(() => {
    console.log("Aktuelle userId in 3_4.js:", userId);
  }, [userId]);

  const handleLogout = () => {
    
    auth
      .signOut()
      .then(() => {
        
        window.location.href = "/login"; 
      })
      .catch((error) => {
        console.error("Logout fehlgeschlagen:", error);
      });
  };

  const handleAnswerChange = (questionIndex, value) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionIndex]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const correctAnswers = questions.every(
      (q, index) => selectedAnswers[index] === q.correct
    );

    if (correctAnswers) {
      try {
        if (!userId) {
          console.error("userId ist nicht definiert");
          setError("Ein Fehler ist aufgetreten.");
          return;
        }

       
        const userDoc = await db.collection("users").doc(userId).get();

        console.log("userDoc:", userDoc.exists); 

        if (userDoc.exists) {
          
          await db
            .collection("users")
            .doc(userId)
            .update({
              lastChapter: "3_4",
              completedChapters:
                firebase.firestore.FieldValue.arrayUnion("3_4"),
            });
          console.log("Dokument aktualisiert mit Kapitel 3_4.");
        } else {
          
          await db
            .collection("users")
            .doc(userId)
            .set({
              lastChapter: "3_4",
              completedChapters: ["3_4"],
            });
          console.log("Dokument erstellt mit Kapitel 3_4.");
        }

        navigate("/3_5"); 
      } catch (error) {
        console.error("Fehler beim Aktualisieren des Fortschritts:", error);
        setError("Ein Fehler ist aufgetreten. Versuche es später erneut.");
      }
    } else {
      setError("Die Antworten sind nicht korrekt. Versuche es erneut.");
    }
  };
  return (
    <div className="container">
      <div className="container py-5">
        <img
          src="/images/zebbs_Logo.svg"
          class="d-block mx-auto mb-4"
          alt=""
          style={{ width: "20%" }}
        />
        <div className="d-flex justify-content-between align-items-center mb-5 p-3 bg-body-tertiary rounded-3">
          {/* Breadcrumbs */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-chevron mb-0">
              {/* Startseite (Home) */}
              <li className="breadcrumb-item">
                <Link className="link-body-emphasis" to="/course-overview">
                  <i className="bi bi-house-door-fill"></i>
                  <span className="visually-hidden">Home</span>
                </Link>
              </li>

              {/* Library Link */}
              <li className="breadcrumb-item">
                <Link
                  className="link-body-emphasis fw-semibold text-decoration-none"
                  to="/course-overview"
                >
                  3. Angriffe und Risiken
                </Link>
              </li>

              {/* Aktuelle Seite */}
              <li className="breadcrumb-item active" aria-current="page">
                Denial-of-Service (DoS) und Distributed Denial-of-Service (DDoS)
                Angriffe
              </li>
            </ol>
          </nav>

          {/* Logout-Button */}
          <button className="btn btn-outline-dark" onClick={handleLogout}>
            Logout
          </button>
        </div>

        <div
          className="p-5 m-0 rounded-3"
          style={{
            position: "relative",
            backgroundColor: "#009fe0",
            margin: "25px",
            textAlign: "center",
          }}
        >
          <h3 className="text-center p-3">Kapitel 3: Angriffe und Risiken</h3>
          <h2 className="text-center p-3">
            Denial-of-Service (DoS) und Distributed Denial-of-Service (DDoS)
            Angriffe
          </h2>

          <img
            src="/images/ddos.webp"
            alt="ddos-Injection"
            style={{ position: "relative", maxWidth: "35%", height: "auto" }}
          />
        </div>

        <div className="p-5 text-center">
          <h2 className="p-5">
            Denial-of-Service (DoS) und Distributed Denial-of-Service (DDoS)
          </h2>
          <p className="col-lg-11 mx-auto">
            DoS- und DDoS-Angriffe gehören zu den bevorzugten Mitteln um
            digitale Infrastrukturen lahmzulegen. Diese Angriffe überlasten
            Netzwerke, Server und Anwendungen mit einer Flut von Anfragen, bis
            die Systeme unter der Last zusammenbrechen und nicht mehr erreichbar
            sind.
            <br />
            <br />
            Die Folgen solcher Angriffe sind oft schwerwiegend: Unternehmen
            verlieren Umsätze, wenn ihre digitalen Plattformen nicht erreichbar
            sind. Sie riskieren zusätzlich ihren Ruf, da Kunden und Partner
            Sicherheitsmängel vermuten könnten. Geschäftliche Abläufe werden
            unterbrochen, insbesondere bei Unternehmen, die auf Cloud- oder
            webbasierte Tools angewiesen sind. Besonders kritisch ist es, wenn
            essenzielle Dienste wie Krankenhäuser oder Versorgungsbetriebe
            betroffen sind. Hier können Ausfälle lebensbedrohlich sein. <br />
            <br />
            Gleichzeitig erfordern solche Angriffe erhebliche Ressourcen zur
            Abwehr und Wiederherstellung, was Unternehmen viel Zeit und Geld
            kostet. Selbst der Zugang zu wichtigen Informationen auf
            behördlichen Websites oder Nachrichtenportalen kann durch diese
            Angriffe blockiert werden.
          </p>

          <p className="col-lg-11 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
            <img
              src="/images/fact.svg"
              alt="Transparent"
              style={{
                position: "relative",
                maxWidth: "8%",
                height: "auto",
              }}
            />
            Der BSI-Bericht 2024 zeigt eine alarmierende Entwicklung: Die
            Häufigkeit und Qualität von DDoS-Angriffen haben signifikant
            zugenommen. Hochvolumige Angriffe mit Bandbreiten von über 10.000
            Megabit pro Sekunde erreichten im ersten Halbjahr 2024 einen
            durchschnittlichen monatlichen Anteil von 13% – fast das Doppelte
            des langjährigen Durchschnitts von 6,75%. Diese Eskalation wird
            nicht nur durch die technischen Angriffe selbst spürbar, sondern
            auch durch die gezielte mediale Inszenierung. Angreifer übertreiben
            die Auswirkungen dieser Überlast-Attacken in sozialen Netzwerken, um
            gesellschaftliche Unsicherheit und Misstrauen zu verstärken – ein
            strategischer Schachzug, der digitale Sicherheitsbedrohungen mit
            psychologischen Effekten kombiniert.
          </p>
          <h3 className="p-5">Motive für DoS- und DDoS-Angriffe</h3>
          <p className="col-lg-11 mx-auto">
            Die primären Ziele von DoS- und DDoS-Angriffen sind die Störung der
            Verfügbarkeit von Diensten und das Verursachen von Chaos. Solche
            Angriffe können verschiedene Absichten verfolgen, wie zum Beispiel{" "}
            <strong>finanzielle Erpressung</strong>, bei der Angreifer
            Unternehmen drohen, den Angriff fortzusetzen, wenn kein Lösegeld
            gezahlt wird. <br />
            <br />
            <strong>Ideologische und politische </strong> Ziele sind ein
            weiterer Faktor. Hacktivisten nutzen diese Angriffe, um Proteste zu
            unterstützen oder auf Missstände aufmerksam zu machen. Selbst{" "}
            <strong>wirtschaftliche Rivalität </strong> spielt eine Rolle, wenn
            Konkurrenten gezielt Angriffe initiieren, um Geschäftsprozesse zu
            stören und Marktanteile zu gewinnen.
          </p>
        </div>
      </div>

      <div className="gelb-section">
        <div className="container p-5">
          <div className="p-5 text-center">
            <h3 className="p-5">
              Was ist ein Denial-of-Service (DoS) Angriff?
            </h3>
            <p className="col-lg-11 mx-auto">
              Denial-of-Service (DoS) könnte man mit „Dienstverweigerung“
              (Denial=Verweigerung) übersetzen. Ein Denial-of-Service (DoS)
              Angriff wird in der Regel von einem einzelnen Angreifer
              ausgeführt, der versucht, einen Dienst oder eine Website zu
              überlasten, indem er eine große Anzahl von Anfragen sendet. Diese
              Überlastung führt dazu, dass das Zielsystem nicht mehr in der Lage
              ist,
              <span
                data-tooltip-id="tooltip-legitim"
                data-tooltip-content="Eine legitime Anfrage ist eine berechtigte und rechtmäßige Anfrage von einem autorisierten Benutzer oder System, die im normalen Betrieb eines Dienstes oder Netzwerks gestellt wird, wie etwa das Laden einer Webseite oder das Abrufen von Daten.
              "
                className="custom-tooltip-trigger"
              >
                legitime Anfragen
              </span>
              zu verarbeiten.
              <br />
              <br />
              Ein typisches Beispiel für einen DoS-Angriff ist der{" "}
              <strong> „Ping of Death“.</strong> Ziel ist es hier, z. B. eine
              Website zum Absturz zu bringen oder sie unbrauchbar zu machen,
              indem sie mit speziell präparierten „Ping“-Anfragen überflutet
              wird.
              <br />
              <br />
              Ein „Ping“ ist eigentlich ein ganz normaler Netzwerkbefehl, der
              verwendet wird, um zu überprüfen, ob ein bestimmtes Gerät in einem
              Netzwerk erreichbar ist. Der Befehl sendet eine kleine Datenmenge,
              ein so genanntes „ICMP-Paket“ (Internet Control Message Protocol),
              an das Zielgerät und das Zielgerät antwortet mit einer
              entsprechenden Nachricht. Der "Ping" ist ein nützliches Werkzeug
              für die Netzwerkdiagnose.
              <br />
              <br />
              Beim „Ping of Death“ wird diese normale Funktion jedoch
              missbraucht. Der Angreifer sendet absichtlich ein manipuliertes
              ICMP-Paket, das größer ist, als es das Zielsystem verarbeiten
              kann. Früher waren Betriebssysteme und Netzwerksysteme nicht in
              der Lage, mit solchen übergroßen Paketen umzugehen, weil sie die
              Daten nicht korrekt aufteilen und verarbeiten konnten. Dies führte
              dazu, dass das Zielsystem versuchte, das große Paket zu
              verarbeiten, dabei jedoch abstürzte oder sich aufhängte, weil es
              die Datenmenge nicht bewältigen konnte.
              <br />
              <br />
              Dieser Angriff war besonders effektiv in den 1990er Jahren, als
              viele Systeme noch anfällig für diese Art von Überlastung waren.
              Moderne Systeme und Netzwerke sind mittlerweile so konfiguriert,
              dass sie die übergroßen ICMP-Pakete erkennen und abwehren können.
              Daher ist der „Ping of Death“ heute weniger verbreitet. Aber er
              bleibt ein klassisches Beispiel dafür, wie selbst einfache
              Netzwerkbefehle ausgenutzt werden können, um Schaden anzurichten.
            </p>
            <ReactTooltip
              id="tooltip-legitim"
              place="top"
              className="custom-tooltip"
            />
          </div>
        </div>
      </div>
      <div className="white-section">
        <div className="container p-5">
          <div className="p-5 text-center">
            <h3 className="p-5">
              Was ist ein Distributed Denial-of-Service (DDoS) Angriff?
            </h3>
            <p className="col-lg-11 mx-auto">
              DDoS-Angriffe sind eine erweiterte Form von DoS-Angriffen. Während
              der DoS-Angriff von einem einzelnen Computer ausgeht, wird bei
              einem DDoS-Angriff eine Vielzahl von Computern genutzt, um
              gleichzeitig eine enorme Menge an Anfragen an ein Ziel zu senden.
              Diese Angriffe sind besonders schwer abzuwehren, da die Anfragen
              von vielen verschiedenen Quellen stammen und oft legitimen
              Datenverkehr nachahmen, wodurch ihr Erkennen erschwert wird.
              <br />
              <br />
              Der Angreifer schließt dafür infizierte Computer zu einem riesigen
              Netzwerk, einem sogenannten <strong>Botnet,</strong> zusammen, das
              heimlich von ihm kontrolliert wird. Das Ziel eines Botnet ist es,
              eine große Menge an Rechenleistung und Netzwerkressourcen zu
              bündeln um dann einen Denial-of-Service (DDoS) Angriff zu starten.{" "}
              <br />
              <br />
              Dafür verbreitet der Angreifer Schadsoftware, die Computer
              infiziert und sie in das Botnet eingliedert. Diese Computer, oft
              Tausende oder sogar Millionen weltweit, bleiben in der Regel
              funktionsfähig, sodass der Eigentümer nichts Verdächtiges bemerkt.
              Alle infizierten Bots werden über einen „Befehls- und
              Kontrollserver“ vom Angreifer gesteuert. Wenn er einen
              DDoS-Angriff starten möchte, sendet er über den Kontrollserver den
              Befehl an alle Bots, gleichzeitig Anfragen an das Zielsystem zu
              senden. Da die Anfragen alle gleichzeitig kommen, wird das
              Zielsystem mit einer enormen Menge an Datenverkehr überflutet.
              Dies führt zu einer Überlastung und im schlimmsten Fall zu einem
              Betriebsausfall.
              <br /> <br />
              Botnets machen DDoS-Angriffe gefährlich, weil sie die Macht eines
              einzelnen Angreifers multiplizieren. Während ein einzelner
              Computer in der Regel nicht genug Datenverkehr erzeugen kann, um
              so einen verheerenden Schaden anzurichten, kann ein Botnet mit
              Tausenden von Computern eine überwältigende Menge an Anfragen
              generieren. Das dabei die Anfragen von vielen verschiedenen Orten
              gleichzeitig kommen, mach es noch schwieriger, den Angriff zu
              blockieren.
            </p>

            <p className="col-lg-11 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
              <img
                src="/images/attack.svg"
                alt="Transparent"
                style={{
                  position: "relative",
                  maxWidth: "8%",
                  height: "auto",
                }}
              />
              Im Jahr 2013 gab es einen der massivsten DDoS-Angriffe, der als
              „Spamhaus-Angriff“ bekannt wurde. Zielscheibe war die Schweizer
              gemeinnützige Organisation Spamhaus. Spamhaus verwaltet schwarze
              Listen, in denen die IP-Adressen diverser Spam-Anbieter vermerkt
              werden. Der Angriff erreichte eine Spitzenlast von 300 Gigabit pro
              Sekunde. Dies war genug Datenverkehr, um sogar das gesamte
              Internet in Teilen Europas zu verlangsamen!
            </p>
          </div>
        </div>
      </div>

      <div className="my-5 container">
        <div
          className="safe p-5 rounded-2 text-center"
          style={{ backgroundColor: "#fec748" }}
        >
          <img
            src="/images/abwehr.svg"
            alt="Abwehr"
            style={{
              position: "relative",
              maxWidth: "7%",
              height: "auto",
            }}
          />
          <h3 className="p-5">Abwehrstrategien gegen DoS- und DDoS-Angriffe</h3>
          <p className="col-lg-11 mx-auto">
            Eine effektive Abwehr gegen DoS- und DDoS-Angriffe erfordert eine
            Kombination aus technischen und organisatorischen Maßnahmen.
          </p>
          <h4 className="p-3">Technische Maßnahmen:</h4>{" "}
          <p className="col-lg-11 mx-auto">
            Eine gut durchdachte Netzwerkstruktur kann helfen, die Auswirkungen
            solcher Angriffe zu verringern.
            <br />
            <br /> Beim <strong>Load Balancing </strong>wird der Datenverkehr
            auf mehrere Server verteilt, damit ein einzelner Server nicht
            überlastet wird. Außerdem kann ein{" "}
            <span
              data-tooltip-id="tooltip-cdn"
              data-tooltip-content="Ein Content Delivery Network (CDN) ist ein Netzwerk von Servern, die weltweit verteilt sind, um Inhalte wie Webseiten schneller zu liefern. Wenn du eine Webseite besuchst, bekommst du die Daten vom nächstgelegenen Server im CDN, was die Ladezeit verkürzt und die Webseite vor Überlastung schützt.
              "
              className="custom-tooltip-trigger"
            >
              Content Delivery Network (CDN){" "}
            </span>
            verwendet werden, um den Datenverkehr auf verschiedene Standorte
            weltweit zu verteilen. <br />
            <br />
            <strong>Firewalls und Router </strong> können so eingerichtet
            werden, dass sie verdächtigen Datenverkehr erkennen und blockieren.
            Zum Beispiel indem sie bestimmte{" "}
            <span
              data-tooltip-id="tooltip-ip"
              data-tooltip-content="Eine IP-Adresse (Internet Protocol Address) ist eine eindeutige Nummer, die Geräten wie Computern, Smartphones oder Servern zugewiesen wird, damit sie in einem Netzwerk kommunizieren können. Sie funktioniert wie eine Adresse, um Daten zwischen Geräten zu senden und zu empfangen."
              className="custom-tooltip-trigger"
            >
              {" "}
              IP-Adressen{" "}
            </span>{" "}
            filtern oder die Anzahl der Anfragen pro Sekunde begrenzen (Rate
            Limiting). <br />
            <br />
            Spezielle Sicherheitssysteme, sogenannte{" "}
            <strong>
              Intrusion Detection und Prevention Systems (IDPS),{" "}
            </strong>{" "}
            können ungewöhnliches Verhalten im Datenverkehr aufspüren und
            verdächtige Aktivitäten automatisch blockieren oder melden. Das IDPS
            analysiert den Datenverkehr oder Systemaktivitäten und vergleicht
            diese mit bekannten Angriffsmustern (Signaturen) oder Anomalien, um
            potenzielle Bedrohungen zu identifizieren. Es alarmiert
            Administratoren oder protokolliert Vorfälle. Zusätzlich zur
            Erkennung kann ein IDPS erkannte Angriffe aktiv blockieren, indem es
            beispielsweise schädlichen Datenverkehr filtert, IP-Adressen sperrt
            oder betroffene Dienste isoliert.
          </p>{" "}
          <ReactTooltip
            id="tooltip-cdn"
            place="top"
            className="custom-tooltip"
          />
          <ReactTooltip
            id="tooltip-ip"
            place="top"
            className="custom-tooltip"
          />
          <h4 className="p-3">Notfallpläne und Reaktionsstrategien</h4>{" "}
          <p className="col-lg-11 mx-auto">
            Unternehmen sollten Notfallpläne für den Fall eines DoS- oder
            DDoS-Angriffs entwickeln. Diese Pläne sollten klare Anweisungen
            enthalten, wie auf einen Angriff zu reagieren ist, einschließlich
            der Benachrichtigung von Kunden. Daneben ist eine kontinuierliche
            Überwachung des Netzwerks entscheidend, um ungewöhnliche Aktivitäten
            frühzeitig zu erkennen.
          </p>
        </div>
      </div>

      {/* Fragenteil */}
      <div className="container pt-5 my-5">
        <div className="text-center m-4">
          <h2>Überprüfe dein Wissen</h2>
          <p className="col-lg-11 mx-auto">
            Mit den richtigen Antworten kommst du weiter!
          </p>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-10 text-start">
            <form onSubmit={handleSubmit}>
              {questions.map((question, index) => (
                <div key={index} className="mb-4">
                  <p className="fs-4">{question.question}</p>{" "}
                  {question.options.map((option) => (
                    <div key={option.value} className="form-check">
                      <input
                        className="form-check-input me-2"
                        type="radio"
                        name={`question${index}`}
                        value={option.value}
                        checked={selectedAnswers[index] === option.value}
                        onChange={() => handleAnswerChange(index, option.value)}
                      />
                      <label className="form-check-label fs-5">
                        {option.label}
                      </label>{" "}
                    </div>
                  ))}
                </div>
              ))}
              {error && <p className="text-danger">{error}</p>}
              <div className="text-center">
                <button type="submit" className="btn btn-primary">
                  überprüfen
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* Ende Fragenteil */}
    </div>
  );
};

export default Chapter3_4;
